// ======================================================================
// File Name       : EnterprisePreCancelConfirmContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { getCurrentMonthForNotifyCancelEnterprise } from '../../utils/EnterPriseUtils';

class EnterprisePreCancelConfirmContainer extends React.Component {
  getModalOptions() {
    return {
      title: '解約手続きの完了',
      footerBtns: [
        { name: '閉じる', onClick: this.props.hideModal },
      ],
    };
  }

  render() {
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.props.hideModal}>
        <Form className='form-horizontal'>
          <Col className="padding-left-15 padding-top-10 padding-right-clear" sm={12}>
            <p>ご利用いただきありがとうございました。解約手続きが完了しました。</p>
            {/* sprint_20230605_tma START */}
            <p className="margin-top-10">{getCurrentMonthForNotifyCancelEnterprise()}末までは引き続きご利用できます。</p>
            {/* sprint_20230605_tma START */}
            <p className="margin-top-20">解約手続きに関しまして何かご不明な点やご質問がございましたら、いつでもお気軽にお問い合わせください。</p>
            <p className="margin-top-10">どうぞよろしくお願いします。</p>
          </Col>

        </Form>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
});
export default connect(mapStateToProps)(EnterprisePreCancelConfirmContainer);
